var map = {
	"./base/arrow-sl.svg": "4gvf",
	"./base/bet-arrow-sl.svg": "UIcf",
	"./base/close-sl.svg": "Y8jL",
	"./base/combinable-bets-sl.svg": "WBuf",
	"./base/filter-sl.svg": "GwoJ",
	"./base/fullscreen-sl.svg": "dsOf",
	"./base/fullscreenExit-sl.svg": "tafH",
	"./base/info-sl.svg": "cDZ/",
	"./base/locked-sl.svg": "03vr",
	"./base/reload-sl.svg": "L3IF",
	"./base/search-sl.svg": "40hK",
	"./base/sport-bracket-sl.svg": "9J1E",
	"./base/warning-sl.svg": "pUDu",
	"./sports/akrobatlyzovanie-sl.svg": "Hvs+",
	"./sports/alpskelyzovanie-sl.svg": "1Vpe",
	"./sports/americkyfutbal-sl.svg": "XDIA",
	"./sports/atletika-sl.svg": "End/",
	"./sports/australskyfutbal-sl.svg": "526M",
	"./sports/badminton-sl.svg": "6Mxw",
	"./sports/bandyhokej-sl.svg": "GYzs",
	"./sports/baseball-sl.svg": "T7j9",
	"./sports/basketbal-sl.svg": "xqXN",
	"./sports/bedminton-sl.svg": "6Dno",
	"./sports/biatlon-sl.svg": "jsOW",
	"./sports/boby-sl.svg": "kpHv",
	"./sports/bojovesporty-sl.svg": "30h3",
	"./sports/bowls-sl.svg": "y8as",
	"./sports/box-sl.svg": "51Du",
	"./sports/curling-sl.svg": "cxxO",
	"./sports/cyklistika-sl.svg": "QpV9",
	"./sports/cyklistikabmx-sl.svg": "jelO",
	"./sports/cyklokros-sl.svg": "2/OO",
	"./sports/default-sl.svg": "d7aI",
	"./sports/dostihy-sl.svg": "oAra",
	"./sports/drahovacyklistika-sl.svg": "xrjt",
	"./sports/dzudo-sl.svg": "Fe8r",
	"./sports/esports-sl.svg": "PaYQ",
	"./sports/esporty-sl.svg": "ab7c",
	"./sports/favourite-sl.svg": "RnN3",
	"./sports/florbal-sl.svg": "bTdZ",
	"./sports/futbal-sl.svg": "wjNi",
	"./sports/futsal-sl.svg": "VoWT",
	"./sports/golf-sl.svg": "+R+Z",
	"./sports/hadzana-sl.svg": "xf58",
	"./sports/hokej-sl.svg": "kvKY",
	"./sports/hokejbal-sl.svg": "eNmN",
	"./sports/horskacyklistika-sl.svg": "dGna",
	"./sports/inlinehokej-sl.svg": "OqXq",
	"./sports/jachting-sl.svg": "p76E",
	"./sports/jazdectvo-sl.svg": "Gtp8",
	"./sports/kanoistika-sl.svg": "UgKD",
	"./sports/klasickelyzovanie-sl.svg": "enV2",
	"./sports/kolky-sl.svg": "aJuW",
	"./sports/krasokorculovanie-sl.svg": "AmYK",
	"./sports/kriket-sl.svg": "rEyQ",
	"./sports/lakros-sl.svg": "2C8T",
	"./sports/letynalyziach-sl.svg": "TBHj",
	"./sports/lukostrelba-sl.svg": "peyg",
	"./sports/lyzovanie-sl.svg": "ZAIw",
	"./sports/malyfutbal-sl.svg": "JdX7",
	"./sports/modernagymnastika-sl.svg": "l71D",
	"./sports/modernypatboj-sl.svg": "F6Pc",
	"./sports/motorizmus-sl.svg": "ZTjG",
	"./sports/niketv-sl.svg": "VTa7",
	"./sports/olympijskehry-sl.svg": "k3BS",
	"./sports/oskar-sl.svg": "SkAW",
	"./sports/parlamentnevolby-sl.svg": "THts",
	"./sports/plavanie-sl.svg": "DkHe",
	"./sports/plazovyfutbal-sl.svg": "U+EE",
	"./sports/plazovyvolejbal-sl.svg": "4sGc",
	"./sports/plochadraha-sl.svg": "jwsI",
	"./sports/poker-sl.svg": "LjHj",
	"./sports/politika-sl.svg": "1shA",
	"./sports/pool-sl.svg": "7Adg",
	"./sports/pozemnyhokej-sl.svg": "Iooi",
	"./sports/prezidentskevolby-sl.svg": "zEX1",
	"./sports/rugby-sl.svg": "2RaQ",
	"./sports/rychlkanoistika-sl.svg": "fvC5",
	"./sports/rychlokorculovanie-sl.svg": "vsB3",
	"./sports/sach-sl.svg": "8o+g",
	"./sports/salovyfutbal-sl.svg": "e69F",
	"./sports/sane-sl.svg": "mjSh",
	"./sports/sankovanie-sl.svg": "hlrR",
	"./sports/severskakombinacia-sl.svg": "JH5v",
	"./sports/sipky-sl.svg": "Qfm4",
	"./sports/skeleton-sl.svg": "5hZf",
	"./sports/skokydovody-sl.svg": "YW6D",
	"./sports/skokynalyziach-sl.svg": "9M5B",
	"./sports/snooker-sl.svg": "H+Xh",
	"./sports/snowboarding-sl.svg": "mnww",
	"./sports/softball-sl.svg": "j3Yx",
	"./sports/sortrek-sl.svg": "P9UO",
	"./sports/spolocenskestavky-sl.svg": "AupJ",
	"./sports/sportovagymnastika-sl.svg": "uQRe",
	"./sports/sportovelezenie-sl.svg": "Y1BP",
	"./sports/squash-sl.svg": "HtdV",
	"./sports/stolnytenis-sl.svg": "gQQ/",
	"./sports/strelba-sl.svg": "v6lk",
	"./sports/superbonus-sl.svg": "VsXR",
	"./sports/superkurzy-sl.svg": "nSQn",
	"./sports/superponuka-sl.svg": "o0IC",
	"./sports/supersanca-sl.svg": "WYMG",
	"./sports/superstar-sl.svg": "1eKp",
	"./sports/synchrplavanie-sl.svg": "G4Bm",
	"./sports/taekwondo-sl.svg": "FAOk",
	"./sports/tenis-sl.svg": "Ldf4",
	"./sports/triatlon-sl.svg": "cSq9",
	"./sports/veslovanie-sl.svg": "fKaB",
	"./sports/vh_dostihy-sl.svg": "Gt99",
	"./sports/vodnepolo-sl.svg": "OBUp",
	"./sports/vodnyslalom-sl.svg": "yyp1",
	"./sports/volejbal-sl.svg": "ka9R",
	"./sports/vzpieranie-sl.svg": "Gb8+",
	"./sports/xfactor-sl.svg": "+9X5",
	"./turbo-live/corner-kick-sl.svg": "H8fl",
	"./turbo-live/live-analyse-sl.svg": "X35n",
	"./turbo-live/live-back-sl.svg": "RBIP",
	"./turbo-live/live-cashin-sl.svg": "f7rp",
	"./turbo-live/live-collapse-tournaments-out-sl.svg": "sTI9",
	"./turbo-live/live-collapse-tournaments-sl.svg": "9poH",
	"./turbo-live/live-favorite-active-sl.svg": "CGyA",
	"./turbo-live/live-favorite-sl.svg": "MMFI",
	"./turbo-live/live-info-sl.svg": "jIft",
	"./turbo-live/live-mobile-cashin-sl.svg": "eHyq",
	"./turbo-live/live-notify-sl.svg": "ffXV",
	"./turbo-live/live-play-radar-sl.svg": "1Mrw",
	"./turbo-live/live-play-stream-sl.svg": "SB5n",
	"./turbo-live/live-radar-sl.svg": "RTBz",
	"./turbo-live/live-see-other-odds-sl.svg": "sn4D",
	"./turbo-live/live-sl.svg": "rSCU",
	"./turbo-live/live-stats-sl.svg": "zbjX",
	"./turbo-live/live-stream-sl.svg": "xoMT",
	"./turbo-live/live-tickets-sl.svg": "gTT6",
	"./turbo-live/my-matches-sl.svg": "55Rw",
	"./turbo-live/penalty-whistle-sl.svg": "ID2F",
	"./turbo-live/real-cloud-sl.svg": "C3Ut",
	"./turbo-live/tennis-ball-sl.svg": "6Ujj",
	"./turbo-live/wizard-help-sl.svg": "aprQ",
	"./tvnike/slider-arrow-sl.svg": "3Kow",
	"./user/vip-sl.svg": "96Ro"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8qq1";